module.exports = __webpack_public_path__ + "static/img/about1.c9c50db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about1.png
// module id = EMSt
// module chunks = 1